<template>
  <div id="app">
    <Menu v-if="header=== true"></Menu>
      <keep-alive :include="include" :max="10">
        <router-view class="router" ref="router"></router-view>
      </keep-alive>
    <Bottom></Bottom>
  </div>
</template>

<script>

function isKeepAlive($route) {
  return $route.meta.keepAlive === undefined || $route.meta.keepAlive;
}
import Menu from "@/components/header.vue" //头部菜单
import Bottom from "@/components/bottom.vue" //头部菜单
import { mapGetters } from "vuex";
export default {
  name: 'App',
  computed: mapGetters(["header"]),
  data(){
    return{
       include: isKeepAlive(this.$route) ? [this.$route.name] : [],
       history: []
    }
  },
  components:{
    Menu,Bottom
  },
  methods:{
  },
  mounted() {
  },
  watch: {
    $route(to, from) {
      const lastPath = this.history[this.history.length - 1] || {},
        { isReplace, isBack } = this.$router;
      if (isKeepAlive(to) && to.name !== "Login") {
        !this.include.includes(to.name) && this.include.push(to.name);
      }

      if (isKeepAlive(from) && isBack) {
        var index = this.include.indexOf(from.name);
        index !== -1 && this.include.splice(index, 1);
      }

      this.$router.isBack = false;
      this.$router.isReplace = false;
    }
  }
}
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin-top: 40px;
  /* background: #f9f9f9; */
}
</style>



// WEBPACK FOOTER //
// src/App.vue